import baseUrl from "../config/baseUrl";

const sendChasingEmail = async ({
  token,
  contact_id,
  template_id,
  recipient_email,
  document_request_id,
  exclude_document_request_id
}) => {
  const formData = new FormData();
  formData.append("contact_id", contact_id);
  formData.append("template_id", template_id);
  formData.append("recipient_email", recipient_email);
  if (document_request_id) {
    formData.append("document_request_id", document_request_id);
  }
  if (exclude_document_request_id) {
    formData.append("exclude_document_request_id", exclude_document_request_id);
  }

  try {
    const response = await fetch(`${baseUrl}/api/send-chasing-email`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default sendChasingEmail;
